module.exports = __webpack_public_path__ + "img/DOCX.27923ee9.png";